import React from 'react';
import { Button, Checkbox, Grid, FormControl, FormControlLabel, InputAdornment, Typography, FormHelperText, } from '@mui/material';
import { useForm } from 'react-hook-form';
import { Types } from '@wheeebo/polaris-api';
import ValidatableField from './ValidatableField';
function MoveGlobalForm({ onSubmit }) {
    const { register, formState, handleSubmit: validate } = useForm({ mode: 'onChange' });
    const { errors } = formState;
    const [disabled, setDisabled] = React.useState(true);
    const [latitude, setLatitude] = React.useState();
    const [longitude, setLongitude] = React.useState();
    const [altitude, setAltitude] = React.useState();
    const [speed, setSpeed] = React.useState();
    const [land, setLand] = React.useState();
    const handleSubmit = () => {
        setDisabled(true);
        onSubmit(Types.VehicleCommandMoveVehicleGlobal, { latitude, longitude, altitude, speed: speed, land });
        setTimeout(() => setDisabled(false), 2500);
    };
    React.useEffect(() => setDisabled(!latitude || !longitude), [latitude, longitude]);
    return (React.createElement("form", { onSubmit: validate(handleSubmit) },
        React.createElement(Grid, { container: true, spacing: 1 },
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(Typography, { variant: "body2" }, "Specify the geo location of the destination.")),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormControl, { component: "fieldset", fullWidth: true },
                    React.createElement(ValidatableField, { id: "latitude", label: "Latitude", placeholder: "10", type: "number", InputProps: {
                            endAdornment: React.createElement(InputAdornment, { position: "end" }, '\u00b0'),
                        }, inputProps: {
                            step: 'any',
                        }, value: latitude, registerOptions: {
                            required: true,
                            onChange: (e) => setLatitude(parseFloat(e.target.value)),
                        }, register, errors }))),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormControl, { component: "fieldset", fullWidth: true },
                    React.createElement(ValidatableField, { id: "longitude", label: "Longitude", placeholder: "10", type: "number", InputProps: {
                            endAdornment: React.createElement(InputAdornment, { position: "end" }, '\u00b0'),
                        }, inputProps: {
                            step: 'any',
                        }, value: longitude, registerOptions: {
                            required: true,
                            onChange: (e) => setLongitude(parseFloat(e.target.value)),
                        }, register, errors }))),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormControl, { component: "fieldset", fullWidth: true },
                    React.createElement(ValidatableField, { id: "altitude", label: "Altitude", helperTexts: ['Altitude in meters (relative to the home location)'], placeholder: "10", type: "number", InputProps: {
                            endAdornment: React.createElement(InputAdornment, { position: "end" }, "m"),
                        }, inputProps: {
                            step: 'any',
                        }, value: altitude, registerOptions: {
                            onChange: (e) => setAltitude(parseFloat(e.target.value)),
                        }, register, errors }))),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormControl, { component: "fieldset", fullWidth: true },
                    React.createElement(ValidatableField, { id: "speed", label: "Speed", helperTexts: ['Speed of the flight to the destination'], placeholder: "1", type: "number", InputProps: {
                            endAdornment: React.createElement(InputAdornment, { position: "end" }, "m/s"),
                        }, inputProps: {
                            step: 'any',
                        }, value: speed, registerOptions: {
                            onChange: (e) => setSpeed(parseFloat(e.target.value)),
                        }, register, errors }))),
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(FormControlLabel, { control: React.createElement(Checkbox, { value: land, onChange: (_, checked) => setLand(checked) }), label: "Land the vehicle after the flight" }),
                React.createElement(FormHelperText, null, "Tick a box if the vehicle needs to land after the flight to the destination. ")),
            React.createElement(Grid, { item: true, xs: 12, sx: { display: 'flex', justifyContent: 'flex-end' } },
                React.createElement(Button, { type: "submit", disabled: disabled }, "Submit")))));
}
export default React.memo(MoveGlobalForm);
